import React from 'react';
import { Link } from 'react-router-dom';
import { FOOTER_COLUMNS, BRAND } from '../../content/site';
import { Logo } from '../sv';

function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200" data-testid="footer">
      <div className="sv-wrap py-16 pb-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-[1.4fr_repeat(4,1fr)] gap-8">
        <div className="col-span-2 md:col-span-3 lg:col-span-1">
          <Logo />
          <p className="text-sm text-gray-600 mt-3 max-w-[260px]">{BRAND.tagline} Global bulk and container shipping since 1962.</p>
          <p className="text-sm text-gray-600 mt-4 max-w-[260px]">Südvik Line A/S<br />Amerika Plads 38, 2100 Copenhagen, Denmark</p>
        </div>
        {FOOTER_COLUMNS.map(function (col) {
          return (
            <div key={col.title}>
              <div className="text-[15px] font-medium mb-3.5">{col.title}</div>
              <div className="grid gap-2.5">
                {col.links.map(function (l) {
                  return <Link key={l.href + l.label} to={l.href} className="text-sm text-gray-700 hover:text-ink transition-colors duration-[120ms]">{l.label}</Link>;
                })}
              </div>
            </div>
          );
        })}
      </div>
      <div className="border-t border-gray-200">
        <div className="sv-wrap py-5 flex flex-col sm:flex-row justify-between gap-3 text-[13px] text-gray-600">
          <span>© {new Date().getFullYear()} {BRAND.legal}</span>
          <span className="flex flex-wrap gap-x-2">
            <Link to="/legal/terms" className="hover:text-ink">Terms</Link><span>·</span>
            <Link to="/legal/privacy" className="hover:text-ink">Privacy</Link><span>·</span>
            <Link to="/legal/cookies" className="hover:text-ink">Cookie policy</Link><span>·</span>
            <Link to="/legal/bill-of-lading" className="hover:text-ink">Bill of lading terms</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
